export const App = appName => {
  let app
  try {
    app = require('./App' + appName)
  } catch (e) {
    app = require('./App' + process.env.FALLBACK_APP_NAME)
  }
  return app
}
